import { Input } from '@/shared/components/ui/input'
import { FormField } from '../FormField'
import { AddressAutocomplete } from '../AddressAutocomplete'
import type { locationLabel } from '@/shared/types'

export interface LocationData {
  address: string
  latitude: number
  longitude: number
  label: locationLabel
}

interface StepLocationProps {
  data: LocationData
  onChange: (data: LocationData) => void
  errors: Partial<Record<keyof LocationData, string>>
}

export function StepLocation({ data, onChange, errors }: StepLocationProps) {
  return (
    <div className="space-y-6">
      <FormField
        label="Address"
        htmlFor="address"
        required
        error={errors.address}
        helperText="Location will be auto-detected from address"
      >
        <AddressAutocomplete
          value={data.address}
          placeholder="e.g., 123, MG Road, Indiranagar, Bangalore - 560038"
          error={errors.address}
          onChange={(val) => onChange({ ...data, address: val })}
          onSelect={({ address, latitude, longitude }) =>
            onChange({
              ...data,
              address,
              latitude,
              longitude,
            })
          }
        />
      </FormField>

      <div className="grid md:grid-cols-2 gap-4">
        <FormField label="Latitude" htmlFor="latitude">
          <Input
            id="latitude"
            value={data.latitude || ''}
            placeholder="Auto-detected"
            disabled
            className="bg-muted text-muted-foreground"
          />
        </FormField>

        <FormField label="Longitude" htmlFor="longitude">
          <Input
            id="longitude"
            value={data.longitude || ''}
            placeholder="Auto-detected"
            disabled
            className="bg-muted text-muted-foreground"
          />
        </FormField>
      </div>
    </div>
  )
}
